// @flow

import axios from 'axios';
import cache from './../Core/NetworkCache';

import type { Cache } from './../Core/NetworkCache';
import type { ShowPage } from './Objects';

export type Client = {|
  getShowsForProTrackSeries: (series_id: number) => Promise<Array<ShowPage>>,
|};

export default function client(httpClient?: Object): Client {
  const TARGET_SIZE = 100;
  const CAPACITY = 150;

  let innerClient = httpClient || axios;

  // The response cache, capped by the target size.
  let respCache: Cache<Array<ShowPage>> = cache(TARGET_SIZE, CAPACITY, innerClient);

  return {
    getShowsForProTrackSeries: function(series_id: number): Promise<Array<ShowPage>> {
      return respCache.get(`/api/v2/show/series/${series_id}/`);
    }
  };
}